import { Injectable } from '@angular/core';
import { Http } from '@angular/http';
import { Observable } from 'rxjs/Observable';
import { forkJoin } from 'rxjs/observable/forkJoin';
import { catchError, map } from 'rxjs/operators';
import { ApiUrlConstants } from '../../common/constants/api.constants';

@Injectable()
export class ReportService {
    constructor(private _http: Http) { }

    /**
     * To handle the obervable error response
     * @param  {Response|any} error
     */
    private handleErrorObservable(error: Response | any) {
        return Observable.throw(error);
    }

    /**
     * To get POS product sales report
     * @param  {number} storeId
     * @param  {number} posLocationId
     * @param  {any} fromDate
     * @param  {any} toDate
     * @param  {number} pageSize
     * @param  {number} pageNumber
     * @param  {boolean} isDownload
     * @returns Observable
     */
    getPOSProductSalesReport(storeId: number, posLocationId: number, fromDate: any, toDate: any, pageSize?: number, pageNumber?: number, isDownload?: boolean): Observable<any> {
        let url =
            ApiUrlConstants.reportTitanApiUrl + 'stores/' + storeId + '/product-sale-quantity?posLocationId=' + posLocationId
            + '&fromDate=' + fromDate + '&toDate=' + toDate;
        url = url + (pageSize ? '&pageSize=' + pageSize : '');
        url = url + (pageNumber ? '&pageNumber=' + pageNumber : '');
        url = url + ('&isDownload=' + isDownload);
        return this._http.get(url)
            .map((res) => res.json())
            .catch(this.handleErrorObservable);
    }

    /**
     * To get POS order summary report
     * @param  {number} posLocationId
     * @param  {any} fromDate
     * @param  {any} toDate
     * @param  {number} pageNumber
     * @param  {number} pageSize
     * @returns Observable
     */
    getPOSOrderSummaryReport(posLocationId: number, fromDate: any, toDate: any, pageNumber: number, pageSize: number, isDownload, notesRequired:boolean): Observable<any> {
        const url =
            ApiUrlConstants.reportTitanApiUrl + 'pos/' + posLocationId + '/orders' + '?fromDate=' 
            + fromDate + '&toDate=' + toDate + '&pageNumber=' + pageNumber + '&pageSize=' + pageSize + '&isDownload=' + isDownload + '&notesRequired=' + notesRequired;
        return this._http.get(url)
            .map((res) => res.json())
            .catch(this.handleErrorObservable);
    }


     /**
     * To get Orders Report
     * @param  {number} posLocationId
     * @param  {any} fromDate
     * @param  {any} toDate
     * @param  {number} pageNumber
     * @param  {number} pageSize
     * @returns Observable
     */
    getOrdersReport(storeId: [number], fromDate: any, toDate: any, pageNumber: number, pageSize: number, isDownload): Observable<any> {
        let url =
            ApiUrlConstants.reportTitanApiUrl + 'stores/' + storeId + '/orders-report?fromDate=' + fromDate + '&toDate=' + toDate;
        url = url + (pageSize ? '&pageSize=' + pageSize : '');
        url = url + (pageNumber ? '&pageNumber=' + pageNumber : '');
        url = url + ('&isDownload=' + isDownload);
        return this._http.get(url)
            .map((res) => res.json())
            .catch(this.handleErrorObservable);
    }

    getConstructedOrderReportUrl(storeId: [number], fromDate: any, toDate: any, pageNumber: number, pageSize: number, isDownload): string {
        let url: string = ApiUrlConstants.reportTitanApiUrl + 'stores/' + storeId + '/polling-orders-report?fromDate=' + fromDate + '&toDate=' + toDate;
        url = url + (pageSize ? '&pageSize=' + pageSize : '');
        url = url + (pageNumber ? '&pageNumber=' + pageNumber : '');
        url = url + ('&isDownload=' + isDownload);
    
       return url;
     }

     getOrderPollReport(url: string): Observable<any> {
        return this._http
          .get(url)
          .map((res) => res.json())
          .catch(this.handleErrorObservable);
      }
/**
     * To get Orders Report
     * @param  {number} posLocationId
     * @param  {any} fromDate
     * @param  {any} toDate
     * @param  {number} pageNumber
     * @param  {number} pageSize
     * @returns Observable
     */
    getBsnReport(countryId:[number], fromDate: any, toDate: any, pageNumber: number, pageSize: number, isDownload): Observable<any> {
        let url =
        ApiUrlConstants.reportTitanApiUrl + 'country/' + countryId+ '/govId-report?fromDate=' + fromDate + '&toDate=' + toDate;
        url = url + (pageSize ? '&pageSize=' + pageSize : '');
        url = url + (pageNumber ? '&pageNumber=' + pageNumber : '');
        url = url + ('&isDownload=' + isDownload);
        // let url = 'https://apigw-dev.flptitan.com/api/reporttitan/V1/country/157/govId-report?fromDate=2021-12-01&toDate=2022-01-07&pageSize=25&pageNumber=1&isDownload=false'
        return this._http.get(url)
            .map((res) => res.json())
            .catch(this.handleErrorObservable);
    }

    getIBANReport(countryId:[number], fromDate: any, toDate: any, pageNumber: number, pageSize: number, isDownload): Observable<any> {
        let url =
        ApiUrlConstants.reportTitanApiUrl + 'country/' + countryId+ '/iban-report?fromDate=' + fromDate + '&toDate=' + toDate;
        url = url + (pageSize ? '&pageSize=' + pageSize : '');
        url = url + (pageNumber ? '&pageNumber=' + pageNumber : '');
        url = url + ('&isDownload=' + isDownload);
        // let url = 'https://apigw-dev.flptitan.com/api/reporttitan/V1/country/85/iban-report?fromDate=2021-12-01&toDate=2022-01-07&pageSize=25&pageNumber=1&isDownload=false'
        return this._http.get(url)
            .map((res) => res.json())
            .catch(this.handleErrorObservable);
    }
    // orders count report
    getOrdersCountReport(storeId: [number], fromDate: any, toDate: any):Observable<any>{
        let url =
        ApiUrlConstants.reportTitanApiUrl + 'stores/' + storeId + '/orders-count-report?fromDate=' + fromDate + '&toDate=' + toDate;
    // url = url + (pageSize ? '&pageSize=' + pageSize : '');
    // url = url + (pageNumber ? '&pageNumber=' + pageNumber : '');
    // url = url + ('&isDownload=' + isDownload);
    return this._http.get(url)
        .map((res) => res.json())
        .catch(this.handleErrorObservable);
    }

    /**
     * 
     * @param storeId 
     * @param fromDate 
     * @param toDate 
     * @returns 
     */
    getConstructedUrl(storeId: [number], fromDate: any, toDate: any): string {
        let initialurl: string = 
        ApiUrlConstants.reportTitanApiUrl + 'stores/' + storeId + '/polling-order-count-report?fromDate=' + fromDate + '&toDate=' + toDate;
   
   
       return initialurl;
     }

     getOrdersCountsPollReport(url: string): Observable<any> {
        return this._http
          .get(url)
          .map((res) => res.json())
          .catch(this.handleErrorObservable);
      }
    
// getorders dashboard Reports
    getOrdersDashboardReport(storeId: [number], fromDate: any, toDate: any,pageNumber: number, pageSize: number, isDownload):Observable<any>{
        let url =
        ApiUrlConstants.reportTitanApiUrl + 'stores/' + storeId + '/orders-dashboard-report?fromDate=' + fromDate + '&toDate=' + toDate;
    url = url + (pageSize ? '&pageSize=' + pageSize : '');
    url = url + (pageNumber ? '&pageNumber=' + pageNumber : '');
    url = url + ('&isDownload=' + isDownload);
    return this._http.get(url)
        .map((res) => res.json())
        .catch(this.handleErrorObservable);
    }

     /**
     * 
     * @param storeId 
     * @param fromDate 
     * @param toDate 
     * @returns 
     */
      getConstructedOrderDashBoardUrl(storeId: [number], fromDate: any, toDate: any, pageNumber: number, pageSize: number, isDownload): string {
        let url: string = 
        // ApiUrlConstants.reportTitanApiUrl + 'stores/' + storeId + '/polling-orders-dash-board-report?fromDate=' + fromDate + '&toDate=' + toDate;
   
        ApiUrlConstants.reportTitanApiUrl + 'stores/' + storeId + '/polling-order-dashboard-report?fromDate=' + fromDate + '&toDate=' + toDate;
        url = url + (pageSize ? '&pageSize=' + pageSize : '');
        url = url + (pageNumber ? '&pageNumber=' + pageNumber : '');
        url = url + ('&isDownload=' + isDownload);
    
       return url;
     }

     getOrderDashBoardPollReport(url: string): Observable<any> {
        return this._http
          .get(url)
          .map((res) => res.json())
          .catch(this.handleErrorObservable);
      }

      getConstructedIBANDashBoardUrl(countryId: [number], fromDate: any, toDate: any, pageNumber: number, pageSize: number, isDownload): string {
        let url: string = 
        ApiUrlConstants.reportTitanApiUrl + 'country/' + countryId + '/polling-iban-dashboard-report?fromDate=' + fromDate + '&toDate=' + toDate;
        url = url + (pageSize ? '&pageSize=' + pageSize : '');
        url = url + (pageNumber ? '&pageNumber=' + pageNumber : '');
        url = url + ('&isDownload=' + isDownload);
    
       return url;
     }

     getIBANDashBoardPollReport(url: string): Observable<any> {
        return this._http
          .get(url)
          .map((res) => res.json())
          .catch(this.handleErrorObservable);
      }

    /**
     * Get order invoice report
     * @param storeId 
     * @param productCenter 
     * @param statusId 
     * @param fromDate 
     * @param toDate 
     * @param pageSize 
     * @param pageNumber 
     * @param orderNumber 
     * @returns 
     */
    getOrderInvoiceReport(storeId: number, productCenter: string, statusId: any[], fromDate: any, toDate: any, pageSize: number, pageNumber: number, 
        sortColumn: string, sortOrder: string, orderNumber: string, orderStatus: number[]) {
        let url = ApiUrlConstants.reportTitanApiUrl + 'stores/' + storeId + '/order-invoice-report?distributionCenterName=' + productCenter + '&statusId=' + statusId;
        url = url + (fromDate ? '&fromDate=' + fromDate : '');
        url = url + (toDate ? '&toDate=' + toDate : '');
        url = url + (pageSize ? '&pageSize=' + pageSize : '');
        url = url + (pageNumber ? '&pageNumber=' + pageNumber : '');
        url = url + (orderNumber ? '&orderNumber=' + orderNumber : '');
        url = url + (sortColumn ? '&sortBy=' + sortColumn : '');
        url = url + (sortOrder ? '&sortOrder=' + sortOrder : '');
        url = url + (orderStatus ? '&orderStatusId=' + orderStatus : '');       
        return this._http.get(url)
            .map((res) => res.json())
            .catch(this.handleErrorObservable);
    }

    /**
     * Get order invoice report to print
     * @param storeId 
     * @param selectedOrders 
     */
    getOrderInvoicePrintReport(storeId: number, selectedOrders: any[]) {
        let url = ApiUrlConstants.reportTitanApiUrl + 'stores/' + storeId + '/order-invoice-print-report?orderIds=' + selectedOrders;
        return this._http.get(url)
            .map((res) => res.json())
            .catch(this.handleErrorObservable);
    }

    /**
     * To update order invoice print status
     * @param selectedOrders 
     * @param userId 
     */
    updateOrderInvoicePrintStatus(selectedOrders: any[], userId: number, userName: string) {
        const request = {
            'orderIds': selectedOrders,
            'printBy': userId,
            'printByUser': userName
        };
        return (this._http
            .post(ApiUrlConstants.orderApiUrl + '/V1/orders/order-invoice-print', JSON.stringify(request))
            .map((res) => res)
            .catch(this.handleErrorObservable));
    }

    public requestDataFromMultipleLogsFromValenceAndCommuniCation(request:any[]): Observable<any[]> {
       let response6=null;
       let response3=null;
        let response1 = this.getOrderLogsFromDI(request[0],false,null);
        let response4 = this.getOrderLogsFromDI(request[0],null,true);
        let response5 = this.getOrderLogsFromDI(request[1],null,true);
        if(request[2]){
        response6 = this.getOrderLogsFromDI(request[2],null,true);
         response3 = this.getOrderLogsFromDI(request[2],false,null);
        }
        if(response6 && response3){
        // Observable.forkJoin (RxJS 5) changes to just forkJoin() in RxJS 6
        return forkJoin([response1,response3,response4,response5,response6]);
        }else{
            return forkJoin([response1,response4,response5]);
        }
      }

    public requestDataFromMultipleLogs(request:any): Observable<any[]> {
        let response1 = this.getOrderLogsFromDI(request,true,null);
        let response2 = this.getOrderLogsFromDI(request,false,null);
        // Observable.forkJoin (RxJS 5) changes to just forkJoin() in RxJS 6
        return forkJoin([response1, response2]);
      }

getOrderLogsFromDI(request:any,isfd:boolean,communicatation:boolean):Observable<any>{
  let url='';
    if(isfd!==null && !isfd){
        url=ApiUrlConstants.diservice + "request-details";
   }else if (isfd!==null&& isfd){
         url=ApiUrlConstants.schedular + "request-details";
   }
   else if(communicatation!==null && communicatation){
       url=ApiUrlConstants.communicationApiUrl+"communication-logs"
   }
   
    return this._http
        .post(url, JSON.stringify(request))
        .map((res: any) => res.json())
        .catch(this.handleErrorObservable);
    
}

    /**
     * Get order account status changes report
     * @param storeId
     * @param fromDate
     * @param toDate
     * @param pageSize
     * @param pageNumber
     *  @param isDownload
     * @returns
     */
    getAccountStatusChangeReport(storeId: [number], fromDate: any, toDate: any, previousStatus: string, newStatus: string, pageNumber: number, pageSize: number, isDownload?: boolean): Observable<any> {
        let url = ApiUrlConstants.reportTitanApiUrl + 'stores/' + storeId + '/account-status-changes-report?fromDate=' + fromDate + '&toDate=' + toDate;
        url = url + ('&previousStatus=' + previousStatus);
        url = url + ('&newStatus=' + newStatus);
        url = url + (pageSize ? '&pageSize=' + pageSize : '');
        url = url + (pageNumber ? '&pageNumber=' + pageNumber : '');
        url = url + ('&isDownload=' + isDownload);
        return this._http.get(url)
            .map((res) => res.json())
            .catch(this.handleErrorObservable);

    }

    updateProcessingOrderStatus(selectedOrders: string[], userId: number) {
        return this._http
            .put(ApiUrlConstants.orderApiUrl + '/V1/orders/bulk-order-status-update?updatedBy='+userId, selectedOrders)
            .pipe(map((res) => res.json()),
            catchError(this.handleErrorObservable));
    }

    updateDeliveryProcessingOrderStatus(selectedOrders: any) {
        return this._http
            .put(ApiUrlConstants.orderApiUrl + '/V1/orders/bulk-orders-status-change', selectedOrders)
            .pipe(map((res) => res.json()),
                catchError(this.handleErrorObservable));
    }

    getConstructedEnrollmentReportUrl(storeId: [number], fromDate: any, toDate: any, email: string, fboId: string, pageSize: number, pageNumber: number, isDownload?: boolean): string {
        let url = ApiUrlConstants.reportTitanApiUrl + 'stores/' + storeId + '/polling-titan-enrollment-report?';
        url = url + (fromDate ? 'fromDate=' + fromDate : '');
        url = url + (toDate ? '&toDate=' + toDate : '');
        url = url + (email ? '&email=' + encodeURIComponent(email) : '');
        url = url + (fboId ? '&fboId=' + fboId : '');
        url = url + (pageSize ? '&pageSize=' + pageSize : '');
        url = url + (pageNumber ? '&pageNumber=' + pageNumber : '');
        url = url + (isDownload ? '&isDownload=' + isDownload : '');
    
       return url;
     }

    getEnrollmentPollReport(url: string): Observable<any> {
        return this._http.get(url)
            .map((res) => res.json())
            .catch(this.handleErrorObservable);

    }

    getEnrollmentReport(storeId: [number], fromDate: any, toDate: any, email: string, fboId: string, pageSize: number, pageNumber: number, isDownload?: boolean): Observable<any> {
        let url = ApiUrlConstants.reportTitanApiUrl + 'stores/' + storeId + '/titan-enrollment-report?';
        url = url + (fromDate ? 'fromDate=' + fromDate : '');
        url = url + (toDate ? '&toDate=' + toDate : '');
        url = url + (email ? '&email=' + email : '');
        url = url + (fboId ? '&fboId=' + fboId : '');
        url = url + (pageSize ? '&pageSize=' + pageSize : '');
        url = url + (pageNumber ? '&pageNumber=' + pageNumber : '');
        url = url + (isDownload ? '&isDownload=' + isDownload : '');
    
        return this._http.get(url)
        .map((res) => res.json())
        .catch(this.handleErrorObservable);
     }

}


// WEBPACK FOOTER //
// ./src/app/customerservice/services/report.service.ts